import { render } from "./EntityView.vue?vue&type=template&id=747ff21a"
import script from "./EntityView.vue?vue&type=script&lang=js"
export * from "./EntityView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__